import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { X, Copy, Check, ExternalLink } from 'lucide-react';
import api from '../api/axios';

export default function AvisQRModal({ bookingId, clientNom, onClose }) {
  const [url,     setUrl]     = useState('');
  const [loading, setLoading] = useState(true);
  const [copied,  setCopied]  = useState(false);
  const [error,   setError]   = useState('');

  useEffect(() => {
    api.post(`/avis/booking/${bookingId}/token`)
      .then(r => {
        const token = r.data.data.token;
        setUrl(`${window.location.origin}/avis/${token}`);
      })
      .catch(() => setError('Impossible de générer le lien d\'avis'))
      .finally(() => setLoading(false));
  }, [bookingId]);

  const copy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-slate-100 dark:border-slate-800">
          <div>
            <h3 className="font-bold text-slate-900 dark:text-white">Demande d'avis</h3>
            <p className="text-xs text-slate-400 mt-0.5">{clientNom}</p>
          </div>
          <button onClick={onClose}
            className="p-1.5 rounded-xl hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 transition">
            <X size={17} />
          </button>
        </div>

        <div className="px-6 py-6 space-y-5">
          {loading && (
            <div className="flex flex-col items-center py-8">
              <div className="w-8 h-8 rounded-full border-3 border-slate-200 border-t-teal-500 animate-spin mb-3" style={{ borderWidth: 3 }} />
              <p className="text-sm text-slate-400">Génération du QR code…</p>
            </div>
          )}

          {error && (
            <p className="text-center text-sm text-red-500 py-4">{error}</p>
          )}

          {!loading && !error && (
            <>
              <p className="text-sm text-slate-500 dark:text-slate-400 text-center leading-relaxed">
                Montrez ce QR code à votre client - il peut le scanner pour laisser un avis en quelques secondes.
              </p>

              {/* QR code */}
              <div className="flex justify-center">
                <div className="bg-white p-4 rounded-2xl shadow-inner border border-slate-100">
                  <QRCodeSVG value={url} size={180} level="M"
                    fgColor="#0F5F54"
                    imageSettings={{
                      src: '', x: undefined, y: undefined,
                      height: 0, width: 0, excavate: false,
                    }} />
                </div>
              </div>

              <p className="text-center text-xs text-slate-400">
                Le client peut aussi recevoir le lien directement
              </p>

              {/* Actions */}
              <div className="flex gap-2">
                <button onClick={copy}
                  className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition">
                  {copied ? <Check size={14} className="text-emerald-500" /> : <Copy size={14} />}
                  {copied ? 'Copié !' : 'Copier le lien'}
                </button>
                <a href={url} target="_blank" rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-teal-600 text-white text-sm font-bold hover:bg-teal-700 transition">
                  <ExternalLink size={14} />
                  Ouvrir
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
